module.exports = __webpack_public_path__ + "media/images/landing/data/dno-49d2f167fb6955a1f40ceacd4d240a75.png";